
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recupera-password-parto-riparto",
      function () {
        return require("private-next-pages/recupera-password-parto-riparto/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recupera-password-parto-riparto"])
      });
    }
  